import { render, staticRenderFns } from "./VisitMngList.vue?vue&type=template&id=ff567e12&scoped=true"
import script from "./VisitMngList.vue?vue&type=script&lang=js"
export * from "./VisitMngList.vue?vue&type=script&lang=js"
import style0 from "./VisitMngList.vue?vue&type=style&index=0&id=ff567e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff567e12",
  null
  
)

export default component.exports